

<footer class="site-footer footer-dark">
    <!-- FOOTER BLOCKS START -->  
    <div class="footer-top bg-bottom-center bg-no-repeat" style="background-image:url(assets/images/background/footer-map.png);">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="widget widget_about">
                        <h3 class="widget-title">Get Started on Your Journey</h3>
                        <p>Are you ready to take the first step towards a healthier, more balanced life? <a routerLink="/contact"><b>Contact us</b></a> today to schedule a consultation or to learn more about our services.</p>
                        <ul class="social-icons">
                            <!-- <li><a href="#" class="fa fa-facebook" style="color: #000; font-size: 33px;"></a></li> -->
                            <!-- <li><a href="#"  style="color: #000; font-size: 33px;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"><rect width="32" height="32" fill="none"/><path fill="#000" d="M10.488 14.651L15.25 21h7l-7.858-10.478L20.93 3h-2.65l-5.117 5.886L8.75 3h-7l7.51 10.015L2.32 21h2.65zM16.25 19L5.75 5h2l10.5 14z"/></svg>
                            </a></li> -->
                            <li><a href="https://www.linkedin.com/company/so-l-space/" target="_blank" class="fa fa-linkedin" style="color: #000; font-size: 33px;"></a></li>
                            <li><a href="https://www.instagram.com/so_lspace?igsh=cXh5c2g5ZGU3Mndx" target="_blank" class="fa fa-instagram" style="color: #000; font-size: 33px;"></a></li>
                        </ul>
                    </div>                      
                </div>  
                
                <div class="col-lg-4 col-md-6">  
                    <div class="widget widget_newsletter">
                        <h3 class="widget-title">Newsletters</h3>
                        <p>Our newsletters contain useful blog posts, case studies, and other reading materials to help you have an improved approach towards life.</p>
                        <div class="newsletter-bx">
                            <form role="search" method="post">
                                <div class="input-group">
                                    <input name="news-letter" class="form-control" style="background-color: #fff; color: #000; font-size: 16px; "placeholder="Enter Email Address" type="text">
                                    <span class="input-group-btn">
                                        <button type="submit" class="site-button"><i class="fa fa-paper-plane"></i></button>
                                    </span>
                                </div>
                             </form>
                        </div>                                    
                     </div>
               </div> 
            
                <div class="col-lg-4 col-md-6">
                    <div class="widget widget_about">
                        <h3 class="widget-title"><a routerLink="/contact" >Contact Us</a></h3>
                        <p>Have questions or need more information? We’d love to hear from you. Reach out to us via phone, email, or visit our center to explore how we can support your mental wellness journey.</p>
                        <ul class="social-icons-mob">
                       
                            <li><a href="https://www.linkedin.com/company/so-l-space/" target="_blank" class="fa fa-linkedin" style="color: #000; font-size: 33px;"></a></li>
                            <li><a href="https://www.instagram.com/so_lspace?igsh=cXh5c2g5ZGU3Mndx" target="_blank" class="fa fa-instagram" style="color: #000; font-size: 33px;"></a></li>
                        </ul>
                    </div>
                </div>
                
            </div>

            <div class="footer_blocks">
                <div class="row no-gutters">
                    <!-- Block 1 -->
                    <div class="col-lg-4 col-md-4">
                        <div class="block-content">
                            <div class="wt-icon-box-wraper left">
                                <div class="wt-icon-box-sm">
                                    <span class="icon-cell "style="color: #000;"><i class="flaticon-call"></i></span>
                                </div>
                               
                                <div class="icon-content">
                                    <h3 class="widget-title">Call</h3>
                                    <p>+918069095550</p>
                                  

                                </div>
                            </div>
                        </div>
                    </div>
                    

                    <!-- Block 2 -->
                    <div class="col-lg-4 col-md-4">
                        <div class="block-content">
                            <div class="wt-icon-box-wraper left">
                                <div class="wt-icon-box-sm">
                                    <span class="icon-cell "style="color: #000;"><i class="flaticon-email"></i></span>
                                </div>
                                <div class="icon-content">
                                    <h3 class="widget-title">E-mail</h3>
                                    <p >
                                        contact@soulspacecare.com
                                        <!-- <a href="mailto:contact@soulspacecare.com?subject=CONTACT SOUL SPACE&body=">contact@soulspacecare.com</a> -->

                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Block 3 -->
                    <div class="col-lg-4 col-md-4">
                        <div class="block-content">
                            <div class="wt-icon-box-wraper left">
                                <div class="wt-icon-box-sm">
                                    <span class="icon-cell "style="color: #000;"><i class="flaticon-location"></i></span>
                                </div>
                                <div class="icon-content">
                                    <h3 class="widget-title">Address</h3>
                                    <p >Unit Nos. 101A & 101B, 1st Floor, AVA Court, Malibu Towne, Sohna Road, Gurugram, Haryana, India - 122018</p>
                                </div>
                            </div>
                        </div>
                    </div> 
                    
                    
                </div>
            </div>
        </div>
    </div>
    <!-- FOOTER COPYRIGHT -->
</footer>
<!-- FOOTER END -->
